import Spinner from 'react-bootstrap/Spinner';

function LoadSpinner() {
    return <Spinner animation="grow" className="full-center-spinner text-crimson" />;
}

export default LoadSpinner;
